module.exports = __webpack_public_path__ + "img/7.3cf1a136.jpg";